const getCulture = (language, country) => {
  return `${language.slice(0, 2)}-${country}`;
};

module.exports = { getCulture };
